var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#292A2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.945 3.374 6 5.32 4.054 3.375a.48.48 0 0 0-.68 0l-.033.036a.482.482 0 0 0 .033.644L5.32 6 3.375 7.946a.48.48 0 0 0 .34.82l.047-.002a.474.474 0 0 0 .293-.138L6 6.68l1.946 1.945a.48.48 0 0 0 .82-.34l-.002-.047a.469.469 0 0 0-.138-.292L6.68 6l1.946-1.946a.48.48 0 1 0-.68-.68z"
  }))));
};

export default SvgDelete;